module.exports = __webpack_public_path__ + "static/media/logo.c228b9b0.png";